import React from 'react';
import '../../styles/CantoPublications.css';

export default function CantoPublications() {
  return (
    <div className='canto-publications-page'>
      <div className='canto-publications-header'>
        <div className='canto-publications-label'>Publications</div>
        <h1 className='canto-publications-title'>Curated Publications Hub</h1>
        <p className='canto-publications-desc'>
          Explore CANTO's curated collection of publications, spanning books, research reports, policy briefs, and industry insights, designed to inform, inspire, and support the advancement of the Caribbean's digital and infrastructure ecosystem. This library reflects the region's thought leadership, capturing emerging trends, best practices, and strategic perspectives shaping a connected and resilient future.
        </p>
      </div>

      <div className='canto-publications-content'>
        <div className='canto-publications-flipsnack'>
          <iframe
            src="https://player.flipsnack.com?hash=N0RFQkM1OTlFOEMremhmdjVhMDk1ZQ=="
            width="100%"
            height="480"
            seamless="seamless"
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            allow="autoplay; clipboard-read; clipboard-write"
            title="CANTO Publications"
          />
        </div>
      </div>
    </div>
  );
}
